
export default {
    name: 'AppBar',
    props: {
        title: String,
        navBackBtn: Object,
        textBtn: Object,
        iconBtn1: Object,
        iconBtn2: Object
    },
    data() {
        return {}
    },
    methods: {
        onNavBackBtnClick() {
            this.$emit('nav-back-btn-click')
        },
        onTextBtnClick() {
            this.$emit('text-btn-click')
        },
        onIconBtn1Click() {
            this.$emit('icon-btn-1-click')
        },
        onIconBtn2Click() {
            this.$emit('icon-btn-2-click')
        }
    }
}
